import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface ObjectTableHeaderRowProps {
  className?: string
  noLeftPadding?: boolean
  noRightPadding?: boolean
}

const ObjectTableHeaderRow: React.FC<
  React.PropsWithChildren<ObjectTableHeaderRowProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: table-row;
        padding: 0px ${styleConstants.widths.cardPaddingXSMUp};

        ${(!!props.noLeftPadding || !!props.noRightPadding) &&
        css`
          padding: 0px;
        `}
      `}
    >
      {props.children}
    </div>
  )
}

export default ObjectTableHeaderRow
